import {
  TweenMax,
} from 'gsap'
import MorphSVGPlugin from './gsap/src/bonus-files-for-npm-users/MorphSVGPlugin'

function getRandomFloat(min, max) {
  return Math.random() * (max - min) + min
}

const electricity = () => {
  const line1 = ['#line-1-s1', '#line-1-s2', '#line-1-s3']
  const line2 = ['#line-2-s1', '#line-2-s2', '#line-2-s3']
  const line3 = ['#line-3-s1', '#line-3-s2', '#line-3-s3']
  const line4 = ['#line-4-s1', '#line-4-s2', '#line-4-s3']
  const line5 = ['#line-5-s1', '#line-5-s2', '#line-5-s3']
  const line6 = ['#line-6-s1', '#line-6-s2', '#line-6-s3']
  const lines = [line1, line2, line3, line4, line5, line6]
  let tl

  // eslint-disable-next-line no-restricted-syntax
  for (const line of lines) {
    tl = new TimelineMax({
      repeat: 200,
      yoyo: true,
    })
    tl.to(line[0], getRandomFloat(1, 4.2), {
      morphSVG: line[1],
      ease: Back.easeInOut.config(getRandomFloat(1, 4)),
    }, '+=0')
      .to(line[0], getRandomFloat(1, 4.5), {
        morphSVG: line[2],
        ease: Back.easeInOut.config(getRandomFloat(1, 4)),
      }, '+=0')
  }

  return tl
}

export default electricity
